import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import {
  EssentialNutrientsRoot,
  VerticalSeparator,
  Title,
  Description,
} from './EssentialNutrients.styles'

type EssentialNutrientsOwnProps = ComponentProps<typeof EssentialNutrientsRoot>
export type EssentialNutrientsProps = EssentialNutrientsOwnProps & {}

export const EssentialNutrients = (_props: EssentialNutrientsProps) => {
  const { t } = useTranslation()

  return (
    <EssentialNutrientsRoot>
      <Stack
        direction={{ '@initial': 'column', '@bp2': 'row' }}
        gap={{ '@initial': '2', '@bp2': '11' }}
      >
        <Title>
          <Text
            size={{ '@initial': 'h3', '@bp2': 'h2' }}
            as="h2"
            weight="bold"
            color="accent-black"
            align={{ '@initial': 'center', '@bp2': 'left' }}
          >
            {t('why-we-feed-raw:essential-nutrients.title')}
          </Text>
        </Title>
        <VerticalSeparator />
        <Description>
          <Stack direction="column" gap="3">
            <Text
              size="headline"
              weight="bold"
              color="accent-black"
              align={{ '@initial': 'center', '@bp2': 'left' }}
            >
              {t('why-we-feed-raw:essential-nutrients.subtitle')}
            </Text>
            <Text
              size="headline"
              color="accent-black"
              align={{ '@initial': 'center', '@bp2': 'left' }}
            >
              {t('why-we-feed-raw:essential-nutrients.description')}
            </Text>
          </Stack>
        </Description>
      </Stack>
    </EssentialNutrientsRoot>
  )
}

EssentialNutrients.displayName = 'EssentialNutrients'
